import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getSystemFile = () => http.get('/system').then(handleResponse);
export const getDateTime = () =>
  http.get('/system/datetime', { timeout: 5000 }).then(handleResponse);

export const startListenerQueue = (params) =>
  http.post('/system/start-listener-queue', params).then(handleResponse);

export const getHost = () => http.get('/webrtc').then(handleResponse);

export const getWhiteLabel = () =>
  http.get('/white-label/settings').then(handleResponse);
